import type { TFunction } from 'i18next'

// Maps known English activity title strings (as returned by the Rails API) to
// their i18n translation keys. Unknown titles fall back to the original string.
const ACTIVITY_TITLE_MAP: Record<string, string> = {
  'Submission Approved':  'activities.submission_approved',
  'Submission Created':   'activities.submission_created',
  'Submission Submitted': 'activities.submission_submitted',
  'Submission Updated':   'activities.submission_updated',
  'Submission Withdrawn': 'activities.submission_withdrawn',
  'Submission Rejected':  'activities.submission_rejected',
  'Submission Expired':   'activities.submission_expired',
  'Study Created':        'activities.study_created',
  'Study Updated':        'activities.study_updated',
  'Site Created':         'activities.site_created',
  'Site Updated':         'activities.site_updated',
  'Status Changed':       'activities.status_changed',
  'Review Started':       'activities.review_started',
  'Review Completed':     'activities.review_completed',
  'Comment Added':        'activities.comment_added',
  'Document Uploaded':    'activities.document_uploaded',
  'Response Required':    'activities.response_required',
}

export function translateActivityTitle(title: string, t: TFunction): string {
  const key = ACTIVITY_TITLE_MAP[title]
  return key ? t(key, { defaultValue: title }) : title
}
